'use strict';exports.__esModule = true;var _extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _reactIdSwiper = require('react-id-swiper');var _reactIdSwiper2 = _interopRequireDefault(_reactIdSwiper);
var _components = require('../../../components');
var _constants = require('../../../constants');
var _galleryParams = require('../../../galleryParams');var _galleryParams2 = _interopRequireDefault(_galleryParams);
var _OMLightbox = require('./OMLightbox.scss');var styles = _interopRequireWildcard(_OMLightbox);
var _iconPdf = require('../../../../static/icons/icon-pdf.png');var _iconPdf2 = _interopRequireDefault(_iconPdf);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}var

OMLightbox = function (_Component) {_inherits(OMLightbox, _Component);function OMLightbox() {var _temp, _this, _ret;_classCallCheck(this, OMLightbox);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.
    state = {
      currentImage: _this.props.currentImage,
      right: 0 }, _this.





















    calculateSizes = function () {var
      isMobile = _this.props.isMobile;
      var imagesLength = (0, _get2.default)(_this.props, 'images.length') || 0;
      var videosLength = (0, _get2.default)(_this.props, 'videos.length') || 0;

      _this.width = document.documentElement.clientWidth;
      _this.thumbnailWidth = 121;
      _this.sideIndent = isMobile ? 18 : 20;
      _this.thumbnailsWidth = isMobile ? _this.width * 0.894 : _this.width * 0.53;
      _this.fullWidth = _this.thumbnailWidth + _this.sideIndent;
      _this.thumbnailsLength = (imagesLength + videosLength) * _this.fullWidth - _this.sideIndent;
      _this.thumbnailCenter = _this.thumbnailsWidth / 2;
      _this.maxRight = _this.thumbnailsLength - _this.thumbnailsWidth;
    }, _this.

    handleKeyDown = function (evt) {
      if (_this.swiperRef) {
        switch (evt.keyCode) {
          case _constants.leftKey:
            return _this.props.isRtl ? _this.swiperRef.swiper.slideNext() : _this.swiperRef.swiper.slidePrev();
          case _constants.rigthKey:
            return _this.props.isRtl ? _this.swiperRef.swiper.slidePrev() : _this.swiperRef.swiper.slideNext();
          default:
            return false;}

      }

      return false;
    }, _this.

    handleThumbnailClick = function (idx) {
      var right = _this.calculateThumbnailTransition(idx);
      _this.swiperRef.swiper.slideTo(idx);
      _this.setState({ currentImage: idx, right: right });
    }, _this.



















    bodyClickHandler = function (evt) {
      if (evt.target.classList.length && _this.props.isOpen) {
        var target = evt.target.classList[0].split('_')[0];
        switch (target) {
          case 'fa':
          case 'image':
          case 'icon':
            return;

          default:
            _this.props.hideLightbox();}

      }
    }, _this.

    slideChange = function () {
      if (_this.swiperRef) {
        var index = _this.swiperRef.swiper.activeIndex;
        _this.calculateThumbnailTransition(index);
        _this.setState({ currentImage: index });
        _this.props.changeLightboxActiveSlide && _this.props.changeLightboxActiveSlide(index);
      }
    }, _this.

    renderPagination = function () {
      var data = [].concat(_this.props.images, _this.props.videos || []);var _ref =
      data[_this.state.currentImage] || {},description = _ref.description;

      return (
        _react2.default.createElement('div', { className: styles.content },
          _react2.default.createElement('div', null, _this.state.currentImage + 1 + ' / ' + data.length),
          description ? _react2.default.createElement('div', { className: styles.description }, description) : null));


    }, _this.




















    renderGallery = function () {var _this$props =
      _this.props,isMobile = _this$props.isMobile,isRtl = _this$props.isRtl;
      var images = (0, _get2.default)(_this.props, 'images') || [];
      var videos = (0, _get2.default)(_this.props, 'videos') || [];

      var gallerySwiperParams = (0, _galleryParams2.default)({
        title: {
          nextParams: '' + _this.props.translate('nextBtn'),
          prevParams: '' + _this.props.translate('prevBtn') },

        className: 'LightboxArrow',
        isMobile: isMobile,
        isRtl: isRtl });


      /* eslint-disable jsx-a11y/media-has-caption */
      return (
        _react2.default.createElement('div', { className: styles.imgContainer },
          _react2.default.createElement(_components.CloseButton, {
            onClose: _this.props.hideLightbox,
            title: '' + _this.props.translate('closeBtn'),
            isMobile: _this.props.isMobile }),


          _react2.default.createElement(_reactIdSwiper2.default, _extends({},
            gallerySwiperParams, {
              on: { slideChange: _this.slideChange },
              ref: function ref(_ref4) {_this.swiperRef = _ref4;},
              initialSlide: _this.state.currentImage,
              noSwiping: images.length <= 1 }),

            images.map(function (_ref2) {var full = _ref2.full,name = _ref2.name,raw = _ref2.raw;
              if (raw) {
                return (
                  _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.image, styles.rawWrapper), key: full },
                    _react2.default.createElement('img', { src: _iconPdf2.default, alt: '' }),
                    _react2.default.createElement('a', { href: full }, name)));


              }

              return (
                _react2.default.createElement('div', { className: styles.image, key: full },
                  _react2.default.createElement('img', { src: full, alt: '' })));


            }),

            videos.map(function (_ref3) {var thumbnail = _ref3.thumbnail,full = _ref3.full;return (
                _react2.default.createElement('div', { className: styles.image, key: thumbnail },
                  _react2.default.createElement('video', {
                      controls: true,
                      poster: thumbnail },

                    _react2.default.createElement('source', { src: full + '.mp4', type: 'video/mp4' }),
                    _react2.default.createElement('source', { src: full + '.ogv', type: 'video/ogv' }),
                    _react2.default.createElement('source', { src: full + '.webm', type: 'video/webm' }))));})),





          _this.renderPagination(),

          _react2.default.createElement('div', {
              className: (0, _classnames2.default)(styles.thumbnailWrapper, _this.props.isRtl ?
              styles.directionRightToLeft :
              styles.directionLeftToRight) },

            _react2.default.createElement('div', {
                className: styles.thumbnailRow,
                style: { width: _this.thumbnailsLength },
                ref: function ref(scrollableAria) {_this.scrollableAria = scrollableAria;} },

              _this.renderThumbnails())),


          _this.props.additionalButton));


    }, _temp), _possibleConstructorReturn(_this, _ret);}OMLightbox.prototype.componentDidMount = function componentDidMount() {this.calculateSizes();window.addEventListener('resize', this.calculateSizes);document.body.addEventListener('keydown', this.handleKeyDown);document.body.addEventListener('click', this.bodyClickHandler);};OMLightbox.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref5) {var currentImage = _ref5.currentImage;if (currentImage !== this.props.currentImage || currentImage !== this.state.currentImage) {this.setState({ currentImage: currentImage });}};OMLightbox.prototype.componentWillUnmount = function componentWillUnmount() {window.removeEventListener('resize', this.calculateSizes);document.body.removeEventListener('keydown', this.handleKeyDown);document.body.removeEventListener('click', this.bodyClickHandler);};OMLightbox.prototype.calculateThumbnailTransition = function calculateThumbnailTransition(idx) {var direction = this.props.isRtl ? '' : '-';var offset = 0;if (this.thumbnailsLength > this.thumbnailsWidth) {var centerPosition = idx * this.fullWidth + this.thumbnailWidth / 2;if (centerPosition < this.thumbnailCenter) {offset = 0;} else if (centerPosition > this.thumbnailsLength - this.thumbnailCenter) {offset = this.maxRight;} else {offset = centerPosition - this.thumbnailCenter;}this.scrollableAria.style.transform = 'translateX(' + direction + offset + 'px)';}return offset;};OMLightbox.prototype.renderThumbnails = function renderThumbnails() {var _this2 = this;var data = [].concat(this.props.images, this.props.videos || []);return data.length > 1 && data.map(function (img, idx) {var _cx;return _react2.default.createElement('div', { key: img.thumbnail, className: (0, _classnames2.default)(styles.thumbnail, (_cx = {}, _cx[styles.active] = _this2.state.currentImage === idx, _cx)), onClick: function onClick() {return _this2.handleThumbnailClick(idx);} }, !img.raw ? _react2.default.createElement('img', { alt: '', src: img.thumbnail, key: img.thumbnail }) : _react2.default.createElement('img', { alt: '', src: _iconPdf2.default, key: img.thumbnail }));});};OMLightbox.prototype.

  render = function render() {var
    isOpen = this.props.isOpen;
    return (
      _react2.default.createElement('div', null,
        _react2.default.createElement(_components.Modal, {
            isOpen: isOpen,
            onRequestClose: this.props.hideLightbox,
            className: 'lightboxModal',
            isMobile: this.props.isMobile,
            isCloseButtonInvisible: true,
            isRtl: this.props.isRtl },

          isOpen && this.renderGallery())));



  };return OMLightbox;}(_react.Component);exports.default = OMLightbox;


OMLightbox.propTypes = {
  isOpen: _propTypes2.default.bool,
  images: _propTypes2.default.array,
  videos: _propTypes2.default.array,
  currentImage: _propTypes2.default.number,
  hideLightbox: _propTypes2.default.func,
  changeLightboxActiveSlide: _propTypes2.default.func,
  translate: _propTypes2.default.func,
  isRtl: _propTypes2.default.bool,
  isMobile: _propTypes2.default.bool,
  additionalButton: _propTypes2.default.element };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/OMContainers/OMLightbox/OMLightbox.js
// module id = 2979
// module chunks = 0